import React, { useState } from 'react';
import './readMoreComponent.scss';

const ReadMoreContent = ({ text, lines, title1, title2, truncatedEndingComponent }) => {
    const textWords = text.split(' ');
    const isContentLong = textWords.length > lines;
    const [expanded, setExpanded] = useState(false);
    const truncatedText = textWords.slice(0, lines).join(' ');
    const displayText = expanded ? text : (isContentLong ? truncatedText + truncatedEndingComponent : text);

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    const shouldShowButton = isContentLong && !expanded;

    return (
        <div className='read-more-main'>
            <div className={shouldShowButton ? 'read-more-text' : ''}>{displayText}</div>
            {isContentLong && (
                <span onClick={toggleExpanded} className="read-more-button" >
                    {expanded ? title2 : title1}
                </span>
            )}
        </div>
    );
};

export default ReadMoreContent;
